<template>
  <v-slide class="v-announce-step">
    <v-text class="v-announce-step__title" heading size="medium">{{title}}</v-text>
    <img :src="imgSrc" class="v-announce-step__image" />
    <div class="v-announce-step__description">
      <slot />
    </div>
  </v-slide>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-announce-step {
  img {
    display: block;
    width: 100%;
  }

  > :not(code) ~ :not(code) {
    margin-top: $spacer * 2;
  }

  &__title,
  &__description {
    // margin-left: $spacer * 2;
    // margin-right: $spacer * 2;
  }
}
</style>
